import { useState } from "react"

import { PlusIcon } from "../../../../shared/components"
import { MinusIcon } from "../../../components/icons"
import { FrameDelay } from "../../../services/FrameDelay"

interface Props {
  delayMs: number
  onChange: (delayMs: number) => void
}

export const DelayStepper = ({ delayMs, onChange }: Props) => {
  // What the visitor is typing; only whole numbers reach the delay, the rest waits for blur.
  const [draft, setDraft] = useState<string | null>(null)

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label="Decrease delay"
        onClick={() => onChange(FrameDelay.clamp(delayMs - FrameDelay.STEP_MS))}
        className="btn btn-circle border-base-content/10 bg-base-200 btn-sm"
      >
        <MinusIcon className="size-3.5" />
      </button>
      <div className="input w-24 gap-2">
        <input
          type="number"
          name="delay_ms"
          min={FrameDelay.MIN_MS}
          max={FrameDelay.MAX_MS}
          step={FrameDelay.STEP_MS}
          inputMode="numeric"
          aria-label="Delay per frame, in milliseconds"
          value={draft ?? delayMs}
          onChange={(event) => {
            const text = event.currentTarget.value
            setDraft(text)
            if (/^\d+$/.test(text)) onChange(FrameDelay.clamp(Number(text)))
          }}
          onBlur={() => setDraft(null)}
          onKeyDown={(event) => {
            if (event.key === "Enter") event.currentTarget.blur()
          }}
          className="min-w-0 flex-1 [appearance:textfield] text-right font-extrabold [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
        <span className="text-xs font-extrabold text-muted-content" aria-hidden="true">
          ms
        </span>
      </div>
      <button
        type="button"
        aria-label="Increase delay"
        onClick={() => onChange(FrameDelay.clamp(delayMs + FrameDelay.STEP_MS))}
        className="btn btn-circle border-base-content/10 bg-base-200 btn-sm"
      >
        <PlusIcon className="size-3.5" />
      </button>
      <span className="text-xs font-semibold text-muted-content">per frame</span>
    </div>
  )
}
